(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["forest-bundle"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('forest-bundle')) {
  customElements.define('forest-bundle', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.querySelector('form');
      this.money = value => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:this.dataset.currency || 'USD'}).format(value / 100);
      this.update = () => {
        let total = 0;
        this.querySelectorAll('[data-bundle-row]').forEach(row => {
          const option = row.querySelector('select').selectedOptions[0];
          const price = Number(option.dataset.price);
          row.querySelector('[data-bundle-price]').textContent = this.money(price);
          if (row.querySelector('input').checked) total += price;
        });
        this.querySelector('[data-bundle-total]').textContent = this.money(total);
      };
      this.form.addEventListener('change', this.update);
      this.form.addEventListener('submit', async event => {
        event.preventDefault();
        const button = this.querySelector('button[type="submit"]');
        const status = this.querySelector('[data-bundle-status]');
        const items = [...this.querySelectorAll('[data-bundle-row]')].filter(row => row.querySelector('input').checked).map(row => { const initials = (row.querySelector('[data-bundle-initials]')?.value || '').trim(); return {id: Number(row.querySelector('select').value), quantity: 1, ...(initials ? {properties:{Initials:initials}} : {})}; });
        if (!items.length) return;
        button.disabled = true;
        status.textContent = 'Adding your selected pieces…';
        try {
          const response = await fetch(this.dataset.addUrl, {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({items})});
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || result.message || 'Unable to add these pieces. Please try again.');
          window.location.assign(this.dataset.cartUrl);
        } catch(error) {
          status.textContent = error.message;
          button.disabled = false;
        }
      });
      this.update();
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
